import { ShareMessageFragment } from "~/__generated__/graphql"
import { getMetaContentMaybe } from "~/common/get-meta-content"
import { ChatShareMessage } from "./components/message/chat-share-message"
import { Logo } from "~/landing/components/logo"
import { useSearchParams } from "react-router-dom"
import { cn } from "~/common/cn"

export const ShareMessageCardScreen = (): JSX.Element => {
  const [searchParams] = useSearchParams()
  const messageData = getMetaContentMaybe("message-data", {
    json: true,
  }) as ShareMessageFragment | null

  const backgroundColor = searchParams.get("bg")
  const rounded = searchParams.get("rounded")

  return (
    <div
      className={cn("relative mx-auto flex w-full flex-col overflow-hidden bg-neutral-100 p-0", {
        "rounded-md": rounded === "true",
      })}
      style={backgroundColor ? { backgroundColor: `#${backgroundColor}` } : undefined}
    >
      <div className="flex flex-col gap-2 px-6 py-6">
        {messageData && (
          <ChatShareMessage
            message={messageData}
            headerRight={<Logo className="h-[30px] shrink-0" />}
          />
        )}
      </div>
    </div>
  )
}

export default ShareMessageCardScreen
